import { getSnapshot, subscribe, type QZState } from '@goshippo/print';

import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

export const useShippoPrintState = <T>(
  selector: (state: QZState) => T,
  isEqual: (a: T, b: T) => boolean = Object.is,
): T => useSyncExternalStoreWithSelector(subscribe, getSnapshot, getSnapshot, selector, isEqual);
